import { Component, ViewEncapsulation, OnInit, Input, ContentChild, ContentChildren, QueryList, OnChanges, SimpleChanges, Output, EventEmitter } from "@angular/core";
import { NpColumnDirective } from "./column.directive";
import { NpEmptyDirective } from "./empty.directive";
import { NpHeaderDirective } from './header.directive';
import { Utils } from "../common/utils";

/**
 * å¯åé¡µè¡¨æ ¼ç»ä»¶ - æ¯æåé¡µãèªå®ä¹ååãèªå®ä¹ååå®¹ç­ãå¯¹äºå¤è¯­è¨ï¼æ¯æéè¿Â·@InputÂ·å±æ§èªå®ä¹ã
 *
 * <example-url>https://stackblitz.com/edit/np-table-sample?embed=1&file=src/app/app.component.html</example-url>
 */
@Component({
  selector: `np-table`,
  templateUrl: 'table.html',
  styleUrls: ['table.scss'],
  encapsulation: ViewEncapsulation.None
})

export class NpTable implements OnInit, OnChanges {

  /**å®ä¹ååç§°ï¼å³æ°æ®æºdatasourceå¯¹è±¡å±æ§åç§°ï¼ï¼åæ¾ç¤ºåç§°ï¼åå®½åº¦ï¼å¯éï¼é»è®¤æ¯åèªéåºç­å®½ï¼ */
  @Input() columns: Array<ColumnDef>;
  /**è¡¨æ ¼ç»ä»¶æ°æ®æºï¼æ°æ®æºä¸ºä¸ä¸ªå¯¹è±¡æ°ç»ï¼å¯¹è±¡çå±æ§åç§°å¿é¡»ä¸è¡¨æ ¼ååç§°ç¸åï¼å¦åä¸ä¼å±ç¤ºæ­¤å */
  @Input() datasource: Array<any>;
  /**æ°æ®æ»æ¡æ° */
  @Input() total: number = 0;
  /**æ¯é¡µæ¾ç¤ºæ¡æ°ï¼é»è®¤20æ¡ */
  @Input() pageSize: number = 20;             // Default is 20 rows per page
  /**æ¯å¦å¨è¡¨å¤´ç¬¬ä¸åå±ç¤ºå¤éæ¡ï¼é»è®¤ä¸å±ç¤º */
  @Input() showCheckbox: boolean = false;     // Indicate whether show checkbox or not, default is not
  /**æ¯å¦æ¾ç¤ºåé¡µç»ä»¶ï¼é»è®¤æ¾ç¤º */
  @Input() showPager: boolean = true;

  /**æ¯å¦æå¡å¨ç«¯æåºï¼é»è®¤falseï¼å³å®¢æ·ç«¯æåº */
  @Input() serverSideSort: boolean = false;

  /**é¦é¡µæé®æå­ */
  @Input() firstBtnText: string = 'é¦é¡µ';
  /**ä¸ä¸é¡µæé®æå­ */
  @Input() preBtnText: string = 'ä¸ä¸é¡µ';
  /**ä¸ä¸é¡µæé®æå­ */
  @Input() nextBtnText: string = 'ä¸ä¸é¡µ';
  /**å°¾é¡µæé®æå­ */
  @Input() lastBtnText: string = 'å°¾é¡µ';
  /**å± */
  @Input() totalText: string = 'å±';
  /**æ¡ï¼æ¯é¡µæ¾ç¤ºæ¡æ° */
  @Input() itemsPerPageText: string = 'æ¡ï¼æ¯é¡µæ¾ç¤ºæ¡æ°';
  /**æ²¡ææ°æ®æé®æå­ */
  @Input() noDataLabel: string = "æ²¡ææ°æ®";
  /**å½åé¡µç  */
  @Input() pageNumber: number = 1;
  /**é¡µç æ¹åäºä»¶ï¼å³ç¿»é¡µäºä»¶ ï¼ååç»å®ï¼ */
  @Output() pageNumberChange = new EventEmitter<number>();

  /**é¡µç æ¹åäºä»¶ï¼å³ç¿»é¡µäºä»¶ */
  @Output() onPageChanged = new EventEmitter<number>();
  /**æ¯é¡µæ¾ç¤ºæ¡æ°æ¹åäºä»¶ */
  @Output() onPageSizeChanged = new EventEmitter<number>();
  /**
   * Will be deprecated, use onRows instead
   */
  @Output() onRowsChecked = new EventEmitter<any>();
  /**
   * Will be deprecated, use onRows instead
   * 
   * ä¸ºäºååå¼å®¹ï¼ææ²¡æä¿®æ¹onRowsCheckedé»è¾ï¼å¢å æ­¤outputäºä»¶
   * 
   * å½åè¡uncheckæ¶è§¦åæ­¤äºä»¶
   */
  @Output() onRowsUnchecked = new EventEmitter<any>();
  /**å½éæ©æå¡å¨ç«¯æåºï¼å³serverSideSort = trueï¼æ¶ï¼æ ¹æ®å½åç¹å»ååå®¹åæåºï¼ä¼ ç»backend apiè¿åæå¡å¨ç«¯æåºæ°æ®èµå¼ç»datasourceåtotalå­æ®µå³å¯ */
  @Output() onServerSideSorted = new EventEmitter<{ col: ColumnDef, sortedBy: 'default' | 'asc' | 'desc' }>();
  /**
   * å½åå¤ççè¡row/rowsï¼éä¸­/ééä¸­ç¶æ
   * 
   * å¦ç¹å»å¨éæé®ï¼åå¤ççæ¯å½åé¡µçææè¡rows
   */
  @Output() onRows = new EventEmitter<any>();

  @ContentChildren(NpColumnDirective) columnComponents: QueryList<NpColumnDirective>;
  @ContentChildren(NpHeaderDirective) headerComponents: QueryList<NpHeaderDirective>;
  @ContentChild(NpEmptyDirective) emptyContent: NpEmptyDirective;

  projectedTemplates: Array<{ name: string, template: any }> = [];
  headerTemplates: Array<{ name: string, template: any }> = [];
  internalColumns: Array<InternalColumnDef> = [];
  /**æ­¤å­æ®µåç»­ä¼åºå¼ will be deprecated */
  selectedRows: Array<any> = [];
  datasourceSortedByDefault: Array<any> = [];

  constructor() { }

  ngOnInit() {
    this.datasourceSortedByDefault = [...this.datasource];

    if (this.showCheckbox) {
      this.internalColumns = [];
      this.internalColumns.push({
        headerName: 'chk',
        headerDisplayName: '',
        width: '50px',
        isCheckbox: true
      });
    }

    this.mergeToInternalColumns();

    this.onServerSideSorted.subscribe(res => {
      console.log('onServerSideSorted: ', res);
      this.buildServerSideSort(res.col);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.columns && changes.columns.currentValue &&
      changes.columns.currentValue.length > 0 &&
      changes.columns.previousValue &&
      changes.columns.previousValue.length > 0 &&
      changes.columns.currentValue !== changes.columns.previousValue) {
      this.mergeToInternalColumns();
      this.projectTemplate();
    }

    if (changes.datasource && changes.datasource.currentValue && changes.datasource.currentValue.length > 0) {
      this.datasourceSortedByDefault = [...changes.datasource.currentValue];
      this.initUniqueIdForDatasource();
    }

    if (changes.total && changes.total.currentValue) {
      this.total = +changes.total.currentValue;
    }

    if (changes.pageNumber && !changes.pageNumber.firstChange && changes.pageNumber.currentValue) {
      const pageNumber = +changes.pageNumber.currentValue;
      this.pageNumber = pageNumber;
      this.pageNumberChange.emit(pageNumber);

      this.selectAll(false);
    }
  }

  ngAfterContentInit() {
    this.projectTemplate();
  }

  onTablePageChanged(currentPageNumber: number) {
    this.pageNumber = currentPageNumber;
    this.pageNumberChange.emit(this.pageNumber);

    this.onPageChanged.next(currentPageNumber);

    this.selectAll(false);
  }

  onTablePageSizeChanged(currentPageSize: number) {
    this.pageSize = currentPageSize;
    this.onPageSizeChanged.next(currentPageSize);

    this.selectAll(false);
  }

  onSelectAllChecked(isChecked: boolean) {
    this.selectAll(isChecked);

    let rows = [];
    if (this.datasource && this.datasource.length > 0) {
      this.datasource.forEach(row => {
        rows.push(row);
      });
    }

    this.onRows.emit(rows);
  }

  onRowSelectChecked(row: any) {
    const colChk = this.internalColumns.find(f => f.headerName === 'chk');
    if (row.checked) {
      if (!this.selectedRows.find(f => f.dt_id === row.dt_id)) {
        this.selectedRows.push(row);
      }
    } else {
      this.selectedRows = this.selectedRows.filter(f => f.dt_id !== row.dt_id);
      this.onRowsUnchecked.next(row);
    }

    if (colChk) {
      colChk.checked = this.selectedRows.length === this.pageSize;
    }

    if (this.selectedRows.length === 0) {
      this.selectAll(false);
    }

    this.onRowsChecked.next(this.selectedRows);

    this.onRows.emit(row);
  }

  onSort(item: InternalColumnDef) {
    if (!item.sort) {
      return;
    }

    if (this.serverSideSort) {
      this.onServerSideSorted.emit({ col: item, sortedBy: item.sortedBy });
      return;
    }

    this.buildClientSideSort(item);
  }

  //#region Private methods
  private buildServerSideSort(item: InternalColumnDef) {
    this.setNextSortedBy(item);
    this.resetOtherSortedColumns(item);
  }

  private buildClientSideSort(item: InternalColumnDef) {
    this.setNextSortedBy(item);
    if (item.sortedBy === 'default') {
      this.datasource = [...this.datasourceSortedByDefault];
    } else {
      this.datasource.sort(Utils.compareValues(item.headerName, item.sortedBy));
    }

    this.resetOtherSortedColumns(item);
  }

  private setNextSortedBy(item: InternalColumnDef) {
    switch (item.sortedBy) {
      case 'default':
        item.sortedBy = 'asc';
        break;
      case 'asc':
        item.sortedBy = 'desc';
        break;
      case 'desc':
        item.sortedBy = 'default';
        break;
      default:
        break;
    }
  }

  private initUniqueIdForDatasource() {
    this.datasource.forEach(row => {
      row['dt_id'] = this.ID();
    });
  }

  private projectTemplate() {
    if (this.columnComponents) {
      this.columnComponents.forEach(item => {
        if (!this.projectedTemplates.find(f => f.name === item.name)) {
          this.projectedTemplates.push({ name: item.name, template: item.cellTemplate });
        }
      });

      this.internalColumns.forEach(column => {
        const projectTemplate = this.projectedTemplates.find(f => f.name === column.headerName);
        if (projectTemplate) {
          column['template'] = projectTemplate.template;
        }
      });
    }
    if (this.headerComponents) {
      this.headerComponents.forEach(item => {
        if (!this.headerTemplates.find(f => f.name === item.name)) {
          this.headerTemplates.push({ name: item.name, template: item.headerTemplate });
        }
      });

      this.internalColumns.forEach(column => {
        const projectTemplate = this.headerTemplates.find(f => f.name === column.headerName);
        if (projectTemplate) {
          column['headerTemplate'] = projectTemplate.template;
        }
      });
    }
  }

  private mergeToInternalColumns() {
    if (this.internalColumns.length === 0) {
      this.internalColumns = [...this.columns];
      this.setSortedByToDefault();
      return;
    }

    this.columns.forEach(replaceColumn => {
      let existColumn = this.internalColumns.find(f => f.headerName === replaceColumn.headerName);
      if (existColumn) {
        existColumn = { ...replaceColumn };
      } else {
        this.internalColumns.push({ ...replaceColumn });
      }
    });

    this.setSortedByToDefault();
  }

  private setSortedByToDefault() {
    for (let i = 0; i < this.internalColumns.length; i++) {
      if (this.internalColumns[i].sort) {
        this.internalColumns[i].sortedBy = 'default';
      }
    }
  }

  private ID() {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return '_' + Math.random().toString(36).substr(2, 9);
  }

  private selectAll(isSelect: boolean) {
    const colChk = this.internalColumns.find(f => f.headerName === 'chk');
    if (colChk) {
      colChk.checked = isSelect;

      this.selectedRows = [];
      if (this.datasource && this.datasource.length > 0) {
        this.datasource.forEach(row => {
          row.checked = isSelect;
          if (isSelect) {
            this.selectedRows.push(row);
          }
        });
      }

      this.onRowsChecked.next(this.selectedRows);
    }
  }

  private resetOtherSortedColumns(item: InternalColumnDef) {
    this.internalColumns.forEach(col => {
      if (col.headerName !== item.headerName && col.sort) {
        col.sortedBy = 'default';
      }
    });
  }
  //#endregion
}

export interface ColumnDef {
  /**ååç§° */
  headerName: string;
  /**åæ¾ç¤ºåç§° */
  headerDisplayName: string;
  /**åå®½åº¦ */
  width?: string;
  sort?: boolean;
}

/**
 * @ignore
 */
interface InternalColumnDef extends ColumnDef {
  isCheckbox?: boolean;
  checked?: boolean;
  sortedBy?: 'default' | 'asc' | 'desc';
}

